import axios from "axios";
import {
	adminEndpoints,
	authEndpoints,
	customerEndpoints,
	matrimoneyEndPoints,
	userEndpoints,
} from "../apis";
// let userType = sessionStorage.getItem("userType")
// 	let sessionStorage.getItem("userType") ? sessionStorage.getItem("token") : localStorage.getItem("token")
// 	if(userType){
// 		sessionStorage.getItem("userType") ? sessionStorage.getItem("token") : localStorage.getItem("token") = sessionStorage.getItem("sessionStorage.getItem("userType") ? sessionStorage.getItem("token") : localStorage.getItem("token")");
// 	}else{
// 		 sessionStorage.getItem("userType") ? sessionStorage.getItem("token") : localStorage.getItem("token") = localStorage.getItem("sessionStorage.getItem("userType") ? sessionStorage.getItem("token") : localStorage.getItem("token")");
// 	}

	
export const registerUser = async (formData) => {
	try {
		const response = await axios.post(authEndpoints.REGISTER_API, formData);
		

		if (!response.data.status) {
			return response.data;
		}
		return response.data;
	} catch (error) {
		return {
			status: false,
			message: error.response?.data?.message || "Registration failed",
		};
	}
};

export const RegistrationOTP = async (data) => {
	try {
		const response = await axios.post(authEndpoints.Registration_OTP_API, {
			mobile: data.mobile,
			otp: data.otp,
		});
		return response.data;
	} catch (error) {
		throw (
			error.response?.data || {
				status: false,
				message: "OTP verification failed",
			}
		);
	}
};

export const mobialLogin = async (mobileNumber) => {
	try {
		const response = await axios.post(authEndpoints.LOGIN_API, {
			mobile: mobileNumber,
		});
		if (!response.data.status) {
			return response.data;
		}
		return response.data;
	} catch (error) {
		return {
			status: false,
			message: error.response?.data?.message || "Login failed",
		};
	}
};

export const loginWithOTP = async (data) => {
	try {
		const response = await axios.post(authEndpoints.VERIFY_LOGIN_API, {
			mobile: data.mobile,
			otp: data.otp,
		});
		if (!response.data.status) {
			return response.data;
		}
		return response.data;
	} catch (error) {
		return {
			status: false,
			message: error.response?.data?.message || "Login failed",
		};
	}
};

export const getCitiesList = async () => {
	try {
		
		const response = await axios.post(
			adminEndpoints.GET_CITIES_LIST,
			{}, // Add any filter parameters here if needed
			{
				headers: {
					Authorization: `Bearer ${sessionStorage.getItem("userType") ? sessionStorage.getItem("token") : localStorage.getItem("token")}`,
				},
			}
		);
		return response.data;
	} catch (error) {
		return {
			status: false,
			message: error.response?.data?.message || "Failed to fetch cities",
			data: [],
		};
	}
};

export const getReligionsList = async () => {
	try {
		
		const response = await axios.post(
			adminEndpoints.GET_RELIGIONS_LIST,
			{ meta: true },
			{
				headers: {
					Authorization: `Bearer ${sessionStorage.getItem("userType") ? sessionStorage.getItem("token") : localStorage.getItem("token")}`,
				},
			}
		);
		return response.data;
	} catch (error) {
		return {
			status: false,
			message: error.response?.data?.message || "Failed to fetch religions",
			data: [],
		};
	}
};

export const getCastesList = async () => {
	try {
		
		const response = await axios.post(
			adminEndpoints.GET_CASTES_LIST,
			{ meta: true }, // Added meta: true
			{
				headers: {
					Authorization:`Bearer ${sessionStorage.getItem("userType") ? sessionStorage.getItem("token") : localStorage.getItem("token")}`,
				},
			}
		);
		return response.data;
	} catch (error) {
		return {
			status: false,
			message: error.response?.data?.message || "Failed to fetch castes",
			data: [],
		};
	}
};

export const getSubCatesList = async (id) => {
	try {
		
		const response = await axios.post(
			adminEndpoints.GET_SUBCASTES_LIST,
			{ meta: true,castId: id}, // Added meta: true
			{
				headers: {
					Authorization:`Bearer ${sessionStorage.getItem("userType") ? sessionStorage.getItem("token") : localStorage.getItem("token")}`,
				},
			}
		);
		return response.data;
	} catch (error) {
		return {
			status: false,
			message: error.response?.data?.message || "Failed to fetch castes",
			data: [],
		};
	}
};
export const getMusicList = async () => {
	try {
		
		const response = await axios.post(
			adminEndpoints.GET_MUSIC_LIST,
			{ meta: true },
			{
				headers: {
					Authorization: `Bearer ${sessionStorage.getItem("userType") ? sessionStorage.getItem("token") : localStorage.getItem("token")}`,
				},
			}
		);
		return response.data;
	} catch (error) {
		return {
			status: false,
			message:
				error.response?.data?.message || "Failed to fetch music preferences",
			data: [],
		};
	}
};

export const getHobbiesList = async () => {
	try {
		
		const response = await axios.post(
			adminEndpoints.GET_HOBBIES_LIST,
			{ meta: true },
			{
				headers: {
					Authorization: `Bearer ${sessionStorage.getItem("userType") ? sessionStorage.getItem("token") : localStorage.getItem("token")}`,
				},
			}
		);
		return response.data;
	} catch (error) {
		return {
			status: false,
			message: error.response?.data?.message || "Failed to fetch hobbies",
			data: [],
		};
	}
};

export const getEducationList = async () => {
	try {
		
		const response = await axios.post(
			adminEndpoints.GET_EDUCATION_LIST,
			{ meta: true },
			{
				headers: {
					Authorization: `Bearer ${sessionStorage.getItem("userType") ? sessionStorage.getItem("token") : localStorage.getItem("token")}`,
				},
			}
		);
		return response.data;
	} catch (error) {
		return {
			status: false,
			message:
				error.response?.data?.message || "Failed to fetch education list",
			data: [],
		};
	}
};

export const getUniversitiesList = async () => {
	try {
		
		const response = await axios.post(
			adminEndpoints.GET_UNIVERSITIES_LIST,
			{ meta: true },
			{
				headers: {
					Authorization: `Bearer ${sessionStorage.getItem("userType") ? sessionStorage.getItem("token") : localStorage.getItem("token")}`,
				},
			}
		);
		return response.data;
	} catch (error) {
		return {
			status: false,
			message: error.response?.data?.message || "Failed to fetch universities",
			data: [],
		};
	}
};

export const getProfessionList = async () => {
	try {
		
		const response = await axios.post(
			adminEndpoints.GET_PROFESSION_LIST,
			{ meta: true },
			{
				headers: {
					Authorization: `Bearer ${sessionStorage.getItem("userType") ? sessionStorage.getItem("token") : localStorage.getItem("token")}`,
				},
			}
		);
		return response.data;
	} catch (error) {
		return {
			status: false,
			message: error.response?.data?.message || "Failed to fetch professions",
			data: [],
		};
	}
};

export const getDesignationList = async () => {
	try {
		
		const response = await axios.post(
			adminEndpoints.GET_DESIGNATION_LIST,
			{ meta: true },
			{
				headers: {
					Authorization: `Bearer ${sessionStorage.getItem("userType") ? sessionStorage.getItem("token") : localStorage.getItem("token")}`,
				},
			}
		);
		return response.data;
	} catch (error) {
		return {
			status: false,
			message: error.response?.data?.message || "Failed to fetch designations",
			data: [],
		};
	}
};

export const getFamilyStatusList = async () => {
	try {
		
		const response = await axios.post(
			adminEndpoints.GET_FAMILY_STATUS_LIST,
			{ meta: true },
			{
				headers: {
					Authorization: `Bearer ${sessionStorage.getItem("userType") ? sessionStorage.getItem("token") : localStorage.getItem("token")}`,
				},
			}
		);
		return response.data;
	} catch (error) {
		return {
			status: false,
			message:
				error.response?.data?.message || "Failed to fetch family status list",
			data: [],
		};
	}
};

export const getFamilyTypeList = async () => {
	try {
		
		const response = await axios.post(
			adminEndpoints.GET_FAMILY_TYPE_LIST,
			{ meta: true },
			{
				headers: {
					Authorization: `Bearer ${sessionStorage.getItem("userType") ? sessionStorage.getItem("token") : localStorage.getItem("token")}`,
				},
			}
		);
		return response.data;
	} catch (error) {
		return {
			status: false,
			message: error.response?.data?.message || "Failed to fetch family types",
			data: [],
		};
	}
};

export const getLookingForList = async () => {
	try {
		
		const response = await axios.post(
			adminEndpoints.GET_LOOKING_FOR_LIST,
			{ meta: true },
			{
				headers: {
					Authorization: `Bearer ${sessionStorage.getItem("userType") ? sessionStorage.getItem("token") : localStorage.getItem("token")}`,
				},
			}
		);
		return response.data;
	} catch (error) {
		return {
			status: false,
			message:
				error.response?.data?.message || "Failed to fetch looking for list",
			data: [],
		};
	}
};

export const updatePersonalDetails = async (formData) => {
	try {
		
		const response = await axios.post(
			matrimoneyEndPoints.UPDATE_PERSONAL_DETAILS,
			formData,
			{
				headers: {
					Authorization: `Bearer ${sessionStorage.getItem("userType") ? sessionStorage.getItem("token") : localStorage.getItem("token")}`,
				},
			}
		);
		return response.data;
	} catch (error) {
		return {
			status: false,
			message:
				error.response?.data?.message || "Failed to update personal details",
		};
	}
};

export const updateEducationDetails = async (formData) => {
	try {
		
		const response = await axios.post(
			matrimoneyEndPoints.UPDATE_NEW_EDUCATIONAL_DETAILS,
			formData,
			{
				headers: {
					Authorization: `Bearer ${sessionStorage.getItem("userType") ? sessionStorage.getItem("token") : localStorage.getItem("token")}`,
				},
			}
		);
		return response.data;
	} catch (error) {
		return {
			status: false,
			message:
				error.response?.data?.message || "Failed to update education details",
		};
	}
};

export const updateNewJobDetails = async (formData) => {
	try {
		
		const response = await axios.post(
			matrimoneyEndPoints.UPDATE_NEW_JOB_DETAILS,
			formData,
			{
				headers: {
					Authorization: `Bearer ${sessionStorage.getItem("userType") ? sessionStorage.getItem("token") : localStorage.getItem("token")}`,
				},
			}
		);
		return response.data;
	} catch (error) {
		return {
			status: false,
			message:
				error.response?.data?.message || "Failed to update education details",
		};
	}
};

export const updateFamilyDetails = async (formData) => {
	try {
		

		const response = await axios.post(
			matrimoneyEndPoints.UPDATE_FAMILY_DETAILS,
			formData,
			{
				headers: {
					Authorization: `Bearer ${sessionStorage.getItem("userType") ? sessionStorage.getItem("token") : localStorage.getItem("token")}`,
				},
			}
		);
		console.log("respose", response);

		return response.data;
	} catch (error) {
		return {
			status: false,
			message:
				error.response?.data?.message || "Failed to update family details",
		};
	}
};

export const updatePartnerDetails = async (formData) => {
	try {
		
		const response = await axios.post(
			matrimoneyEndPoints.UPDATE_PARTNER_DETAILS,
			formData,
			{
				headers: {
					Authorization: `Bearer ${sessionStorage.getItem("userType") ? sessionStorage.getItem("token") : localStorage.getItem("token")}`,
				},
			}
		);
		return response.data;
	} catch (error) {
		return {
			status: false,
			message:
				error.response?.data?.message || "Failed to update partner details",
		};
	}
};

export const getMotherTongueList = async () => {
	try {
		
		const response = await axios.post(
			adminEndpoints.GET_MOTHER_TONGUE_LIST,
			{ meta: true },
			{
				headers: {
					Authorization: `Bearer ${sessionStorage.getItem("userType") ? sessionStorage.getItem("token") : localStorage.getItem("token")}`,
				},
			}
		);
		return response.data;
	} catch (error) {
		return {
			status: false,
			message:
				error.response?.data?.message || "Failed to fetch mother tongue list",
			data: [],
		};
	}
};

export const getStarList = async () => {
	try {
		
		const response = await axios.post(
			adminEndpoints.GET_STAR_LIST,
			{ meta: true },
			{
				headers: {
					Authorization: `Bearer ${sessionStorage.getItem("userType") ? sessionStorage.getItem("token") : localStorage.getItem("token")}`,
				},
			}
		);
		return response.data;
	} catch (error) {
		return {
			status: false,
			message: error.response?.data?.message || "Failed to fetch star list",
			data: [],
		};
	}
};

export const getMoonsignList = async () => {
	try {
		
		const response = await axios.post(
			adminEndpoints.GET_MOONSIGN_LIST,
			{ meta: true },
			{
				headers: {
					Authorization: `Bearer ${sessionStorage.getItem("userType") ? sessionStorage.getItem("token") : localStorage.getItem("token")}`,
				},
			}
		);
		return response.data;
	} catch (error) {
		return {
			status: false,
			message: error.response?.data?.message || "Failed to fetch moonsign list",
			data: [],
		};
	}
};

export const getInterestsList = async () => {
	try {
		
		const response = await axios.post(
			adminEndpoints.GET_INTERESTS_LIST,
			{ meta: true },
			{
				headers: { Authorization: `Bearer ${sessionStorage.getItem("userType") ? sessionStorage.getItem("token") : localStorage.getItem("token")}` },
			}
		);
		return response.data;
	} catch (error) {
		return {
			status: false,
			message:
				error.response?.data?.message || "Failed to fetch interests list",
			data: [],
		};
	}
};

export const getCuisineList = async () => {
	try {
		
		const response = await axios.post(
			adminEndpoints.GET_CUISINE_LIST,
			{ meta: true },
			{
				headers: { Authorization: `Bearer ${sessionStorage.getItem("userType") ? sessionStorage.getItem("token") : localStorage.getItem("token")}` },
			}
		);
		return response.data;
	} catch (error) {
		return {
			status: false,
			message: error.response?.data?.message || "Failed to fetch cuisine list",
			data: [],
		};
	}
};

export const getReadsList = async () => {
	try {
		
		const response = await axios.post(
			adminEndpoints.GET_READS_LIST,
			{ meta: true },
			{
				headers: { Authorization: `Bearer ${sessionStorage.getItem("userType") ? sessionStorage.getItem("token") : localStorage.getItem("token")}` },
			}
		);
		return response.data;
	} catch (error) {
		return {
			status: false,
			message: error.response?.data?.message || "Failed to fetch reads list",
			data: [],
		};
	}
};

export const getSportsList = async () => {
	try {
		
		const response = await axios.post(
			adminEndpoints.GET_SPORTS_LIST,
			{ meta: true },
			{
				headers: { Authorization: `Bearer ${sessionStorage.getItem("userType") ? sessionStorage.getItem("token") : localStorage.getItem("token")}` },
			}
		);
		return response.data;
	} catch (error) {
		return {
			status: false,
			message: error.response?.data?.message || "Failed to fetch sports list",
			data: [],
		};
	}
};

export const getMoviesList = async () => {
	try {
		
		const response = await axios.post(
			adminEndpoints.GET_MOVIES_LIST,
			{ meta: true },
			{
				headers: { Authorization: `Bearer ${sessionStorage.getItem("userType") ? sessionStorage.getItem("token") : localStorage.getItem("token")}` },
			}
		);
		return response.data;
	} catch (error) {
		return {
			status: false,
			message: error.response?.data?.message || "Failed to fetch movies list",
			data: [],
		};
	}
};

export const getDressStyleList = async () => {
	try {
		
		const response = await axios.post(
			adminEndpoints.GET_DRESS_STYLE_LIST,
			{ meta: true },
			{
				headers: { Authorization: `Bearer ${sessionStorage.getItem("userType") ? sessionStorage.getItem("token") : localStorage.getItem("token")}` },
			}
		);
		return response.data;
	} catch (error) {
		return {
			status: false,
			message:
				error.response?.data?.message || "Failed to fetch dress style list",
			data: [],
		};
	}
};

export const getLanguageList = async () => {
	try {
		
		const response = await axios.post(
			adminEndpoints.GET_LANGUAGE_LIST,
			{ meta: true },
			{
				headers: { Authorization: `Bearer ${sessionStorage.getItem("userType") ? sessionStorage.getItem("token") : localStorage.getItem("token")}` },
			}
		);
		return response.data;
	} catch (error) {
		return {
			status: false,
			message:
				error.response?.data?.message || "Failed to fetch languages list",
			data: [],
		};
	}
};

export const getApplicationForList = async () => {
	try {
		
		const response = await axios.post(
			adminEndpoints.GET_APPLICATION_FOR_LIST,
			{ meta: true },
			{
				headers: { Authorization: `Bearer ${sessionStorage.getItem("userType") ? sessionStorage.getItem("token") : localStorage.getItem("token")}` },
			}
		);
		return response.data;
	} catch (error) {
		return {
			status: false,
			message:
				error.response?.data?.message || "Failed to fetch application for list",
			data: [],
		};
	}
};

export const getSourceList = async () => {
	try {
		
		const response = await axios.post(
			adminEndpoints.GET_SOURCE_LIST,
			{ meta: true },
			{
				headers: { Authorization: `Bearer ${sessionStorage.getItem("userType") ? sessionStorage.getItem("token") : localStorage.getItem("token")}` },
			}
		);
		return response.data;
	} catch (error) {
		return {
			status: false,
			message: error.response?.data?.message || "Failed to fetch sources list",
			data: [],
		};
	}
};

export const getNearestBranchList = async () => {
	try {
		
		const response = await axios.post(
			customerEndpoints.GET_NEAREST_BRANCH_LIST,
			{ meta: true },
			{
				headers: { Authorization: `Bearer ${sessionStorage.getItem("userType") ? sessionStorage.getItem("token") : localStorage.getItem("token")}` },
			}
		);
		return response.data;
	} catch (error) {
		return {
			status: false,
			message:
				error.response?.data?.message || "Failed to fetch nearest branch list",
			data: [],
		};
	}
};
export const ContactUs = async () => {
	try {
	  const response = await axios.post(	matrimoneyEndPoints.GET_CONTACTUS_BRANCH_LIST);
	  if (response.data) {
		console.log("Branch List:", response.data);
		return response.data; 
	  }
	} catch (error) {
	  console.error("Error fetching contact us branch list:", error);
	  return null;
	}
  };
export const getEmployedInList = async () => {
	try {
		
		const response = await axios.post(
			adminEndpoints.GET_EMPLOYEDIN_LIST,
			{ meta: true },
			{
				headers: {
					Authorization: `Bearer ${sessionStorage.getItem("userType") ? sessionStorage.getItem("token") : localStorage.getItem("token")}`,
				},
			}
		);
		return response.data;
	} catch (error) {
		return {
			status: false,
			message:
				error.response?.data?.message || "Failed to fetch employed in list",
			data: [],
		};
	}
};

export const getCountriesList = async () => {
	try {
		
		const response = await axios.post(
			adminEndpoints.GET_COUNTRIES_LIST,
			{ meta: true },
			{
				headers: {
					Authorization: `Bearer ${sessionStorage.getItem("userType") ? sessionStorage.getItem("token") : localStorage.getItem("token")}`,
				},
			}
		);
		return response.data;
	} catch (error) {
		return {
			status: false,
			message:
				error.response?.data?.message || "Failed to fetch countries list",
			data: [],
		};
	}
};

export const getStatesList = async () => {
	try {
		
		const response = await axios.post(
			adminEndpoints.GET_STATES_LIST,
			{ meta: true },
			{
				headers: {
					Authorization: `Bearer ${sessionStorage.getItem("userType") ? sessionStorage.getItem("token") : localStorage.getItem("token")}`,
				},
			}
		);
		return response.data;
	} catch (error) {
		return {
			status: false,
			message: error.response?.data?.message || "Failed to fetch states list",
			data: [],
		};
	}
};

export const getDistrictsList = async () => {
	try {
		
		const response = await axios.post(
			adminEndpoints.GET_DISTRICTS_LIST,
			{ meta: true },
			{
				headers: {
					Authorization: `Bearer ${sessionStorage.getItem("userType") ? sessionStorage.getItem("token") : localStorage.getItem("token")}`,
				},
			}
		);
		return response.data;
	} catch (error) {
		return {
			status: false,
			message:
				error.response?.data?.message || "Failed to fetch districts list",
			data: [],
		};
	}
};

export const getProfileDetails = async () => {
	try {
		const response = await axios.get(userEndpoints.GET_PROFILE_API, {
			headers: {
				Authorization: `Bearer ${sessionStorage.getItem("userType") ? sessionStorage.getItem("token") : localStorage.getItem("token")}`,
			},
		});
		console.log("Profile data:", response.data);
		return response.data;
	} catch (error) {
		console.error("GET_PROFILE_DETAILS API ERROR:", error);
		return { status: false, message: error.message };
	}
};

export const getHealthConditionList = async () => {
	try {
		
		const response = await axios.post(
			adminEndpoints.GET_HEALTH_CONDITION_LIST,
			{ meta: true },
			{
				headers: {
					Authorization: `Bearer ${sessionStorage.getItem("userType") ? sessionStorage.getItem("token") : localStorage.getItem("token")}`,
					"Content-Type": "application/json",
				},
			}
		);
		console.log("Health conditions response:", response);
		return response.data;
	} catch (error) {
		console.error("GET_HEALTH_CONDITION_LIST API ERROR:", error);
		return { status: false, message: error.message, data: [] };
	}
};

export const register = async (data) => {
	try {
		const response = await fetch(
			`${process.env.REACT_APP_API_BASE_URL}/customer-register`,
			{
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({
					profileFor: data.profileFor,
					firstName: data.firstName,
					lastName: data.lastName,
					mobile: data.mobile,
					countryCode: data.countryCode,
				}),
			}
		);

		const result = await response.json();
		console.log("REGISTER API RESPONSE............", result);
		return result;
	} catch (error) {
		console.log("REGISTER API ERROR............", error);
		return {
			status: false,
			message: "Registration failed. Please try again.",
		};
	}
};
// export const getCreateStaff=async()=>{
// 	try{
// 		const res= await axios.post(
// 			matrimoneyEndPoints.GET_CREATE_STAFF,
// 		// { meta: true,countryId:id },
// 			{
// 				headers: {
// 					Authorization: `Bearer ${sessionStorage.getItem("userType") ? sessionStorage.getItem("token") : localStorage.getItem("token")}`,
// 				},
// 			}
// 		);
// 		// return response.data;
// 	} catch (error) {
// 		return {
// 			status: false,
// 			message: error.response?.data?.message || "Failed to fetch states list",
// 			data: [],
// 		};
// 	}
// };
export const getStatesListByCountry = async (id) => {
	try {
		
		const response = await axios.post(
			adminEndpoints.GET_STATES_LIST_BY_COUNTRY,
			{ meta: true,countryId:id },
			{
				headers: {
					Authorization: `Bearer ${sessionStorage.getItem("userType") ? sessionStorage.getItem("token") : localStorage.getItem("token")}`,
				},
			}
		);
		return response.data;
	} catch (error) {
		return {
			status: false,
			message: error.response?.data?.message || "Failed to fetch states list",
			data: [],
		};
	}
};

export const getDistrictsListByState = async (id) => {
	try {
		
		const response = await axios.post(
			adminEndpoints.GET_DISTRICTS_LIST_BY_STATE,
			{ meta: true,stateId:id },
			{
				headers: {
					Authorization: `Bearer ${sessionStorage.getItem("userType") ? sessionStorage.getItem("token") : localStorage.getItem("token")}`,
				},
			}
		);
		return response.data;
	} catch (error) {
		return {
			status: false,
			message: error.response?.data?.message || "Failed to fetch states list",
			data: [],
		};
	}
};

export const getCitiessListByDistrict = async (id) => {
	try {
		
		const response = await axios.post(
			adminEndpoints.GET_CITIES_LIST_BY_DISTCT,
			{ meta: true,districtId:id },
			{
				headers: {
					Authorization: `Bearer ${sessionStorage.getItem("userType") ? sessionStorage.getItem("token") : localStorage.getItem("token")}`,
				},
			}
		);
		return response.data;
	} catch (error) {
		return {
			status: false,
			message: error.response?.data?.message || "Failed to fetch states list",
			data: [],
		};
	}
};


export const getRelationsList = async () => {
	try {
		
		const response = await axios.post(
			adminEndpoints.GET_RELATION_LIST,
			{ meta: true }, // Added meta: true
			{
				headers: {
					Authorization:`Bearer ${sessionStorage.getItem("userType") ? sessionStorage.getItem("token") : localStorage.getItem("token")}`,
				},
			}
		);
		return response.data;
	} catch (error) {
		return {
			status: false,
			message: error.response?.data?.message || "Failed to fetch castes",
			data: [],
		};
	}
};

export const getCitiesListByCountry = async (id) => {
	try {
		
		const response = await axios.post(
			adminEndpoints.GET_CITIES_LIST,
			{meta:true,countryId:id}, // Add any filter parameters here if needed
			{
				headers: {
					Authorization: `Bearer ${sessionStorage.getItem("userType") ? sessionStorage.getItem("token") : localStorage.getItem("token")}`,
				},
			}
		);
		return response.data;
	} catch (error) {
		return {
			status: false,
			message: error.response?.data?.message || "Failed to fetch cities",
			data: [],
		};
	}
};

export const updateNewContactDetails = async (formData) => {
	try {
		
		const response = await axios.post(
			matrimoneyEndPoints.UPDATE_NEW_CONTACT_DETAILS,
			formData,
			{
				headers: {
					Authorization: `Bearer ${sessionStorage.getItem("userType") ? sessionStorage.getItem("token") : localStorage.getItem("token")}`,
				},
			}
		);
		return response.data;
	} catch (error) {
		return {
			status: false,
			message:
				error.response?.data?.message || "Failed to update education details",
		};
	}
};

export const updateNewCostDetails = async (formData) => {
	try {
		
		const response = await axios.post(
			matrimoneyEndPoints.UPDATE_NEW_COST_DETAILS,
			formData,
			{
				headers: {
					Authorization: `Bearer ${sessionStorage.getItem("userType") ? sessionStorage.getItem("token") : localStorage.getItem("token")}`,
				},
			}
		);
		return response.data;
	} catch (error) {
		return {
			status: false,
			message:
				error.response?.data?.message || "Failed to update education details",
		};
	}
};

export const updateNewPrsonalDetails = async (formData) => {
	try {
		
		const response = await axios.post(
			matrimoneyEndPoints.UPDATE_NEW_PERSONAL_DETAILS,
			formData,
			{
				headers: {
					Authorization: `Bearer ${sessionStorage.getItem("userType") ? sessionStorage.getItem("token") : localStorage.getItem("token")}`,
				},
			}
		);
		return response.data;
	} catch (error) {
		return {
			status: false,
			message:
				error.response?.data?.message || "Failed to update education details",
		};
	}
};

export const updateNewLifeDetails = async (formData) => {
	try {
		
		const response = await axios.post(
			matrimoneyEndPoints.UPDATE_NEW_LIFE_DETAILS,
			formData,
			{
				headers: {
					Authorization: `Bearer ${sessionStorage.getItem("userType") ? sessionStorage.getItem("token") : localStorage.getItem("token")}`,
				},
			}
		);
		return response.data;
	} catch (error) {
		return {
			status: false,
			message:
				error.response?.data?.message || "Failed to update education details",
		};
	}
};


export const updateNewCApplicationDetails = async (formData) => {
	try {
		
		const response = await axios.post(
			matrimoneyEndPoints.UPDATE_NEW_APPLICATION_DETAILS,
			formData,
			{
				headers: {
					Authorization: `Bearer ${sessionStorage.getItem("userType") ? sessionStorage.getItem("token") : localStorage.getItem("token")}`,
				},
			}
		);
		return response.data;
	} catch (error) {
		return {
			status: false,
			message:
				error.response?.data?.message || "Failed to update education details",
		};
	}

};

export const nearestBranch = async () => {
	try {
		
		const response = await axios.post(
			matrimoneyEndPoints.NEAREST_BRANCH,
			{},
			{
				headers: { Authorization: `Bearer ${sessionStorage.getItem("userType") ? sessionStorage.getItem("token") : localStorage.getItem("token")}` },
			}
		);
		return response.data;
	} catch (error) {
		return {
			status: false,
			message: error.response?.data?.message || "Failed to fetch sources list",
			data: [],
		};
	}
};

export const fetchCastesByReligionId = async (id) => {
	try {
		
		const response = await axios.post(
			adminEndpoints.GET_CASTES_LIST,
			{meta:true}, // Add any filter parameters here if needed
			{
				headers: {
					Authorization: `Bearer ${sessionStorage.getItem("userType") ? sessionStorage.getItem("token") : localStorage.getItem("token")}`,
				},
			}
		);
		return response.data;
	} catch (error) {
		return {
			status: false,
			message: error.response?.data?.message || "Failed to fetch cities",
			data: [],
		};
	}
};

export const personalCertificatesUpload = async (formData) => {
	try {
		
		const response = await axios.post(
				matrimoneyEndPoints.UPDATE_PERSONAL_CERTIFICATES,
				formData,
				{
				  headers: {
					Authorization: `Bearer ${sessionStorage.getItem("userType") ? sessionStorage.getItem("token") : localStorage.getItem("token")}`,
					// "Content-Type": "application/json",
				  },
				}
			  );
			
		return response.data;
	} catch (error) {
		return {
			status: false,
			message: error.response?.data?.message || "Failed to fetch states list",
			data: [],
		};
	}
};

export const uploadProfilePic = async (formData) => {
	try {
		
		const response = await axios.post(
				matrimoneyEndPoints.UPDATE_PROFILE_UPLOAD,
				formData,
				{
				  headers: {
					Authorization: `Bearer ${sessionStorage.getItem("userType") ? sessionStorage.getItem("token") : localStorage.getItem("token")}`,
					// "Content-Type": "application/json",
				  },
				}
			  );
			
		return response.data;
	} catch (error) {
		return {
			status: false,
			message: error.response?.data?.message || "Failed to fetch states list",
			data: [],
		};
	}
};

export const uploadIdProof = async (formData) => {
	try {
		
		const response = await axios.post(
				matrimoneyEndPoints.UPDATE_IDPROOF_UPLOAD,
				formData,
				{
				  headers: {
					Authorization: `Bearer ${sessionStorage.getItem("userType") ? sessionStorage.getItem("token") : localStorage.getItem("token")}`,
					// "Content-Type": "application/json",
				  },
				}
			  );
			
		return response.data;
	} catch (error) {
		return {
			status: false,
			message: error.response?.data?.message || "Failed to fetch states list",
			data: [],
		};
	}
};

export const getVisaTypes = async (formData) => {
	try {
		
		const response = await axios.post(
			adminEndpoints.GET_VISA_TYPES,
				formData,
				{
				  headers: {
					Authorization: `Bearer ${sessionStorage.getItem("userType") ? sessionStorage.getItem("token") : localStorage.getItem("token")}`,
					// "Content-Type": "application/json",
				  },
				}
			  );
			
		return response.data;
	} catch (error) {
		return {
			status: false,
			message: error.response?.data?.message || "Failed to fetch states list",
			data: [],
		};
	}
};

export const commonSubmitData = async (url,formData,token) => {
	try {
		
		const response = await axios.post(
			url,
			formData,
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			}
		);
		return response.data;
	} catch (error) {
		return {
			status: false,
			message:
				error.response?.data?.message || "Failed to update education details",
		};
	}
};
